// extracted by mini-css-extract-plugin
module.exports = {"mobile":"styles_mobile__WbadH","desktop":"styles_desktop__8rPQJ","mobileTitle":"styles_mobileTitle__eQZmG"};